import { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ ADD HERE

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
  const baseUser = {
    uid: firebaseUser.uid,
    email: firebaseUser.email,
  };


// PRIVATE
// PRIVATE
const privateSnap = await getDoc(
  doc(db, "users", firebaseUser.uid)
);

let privateData = {};

if (privateSnap.exists()) {
  privateData = privateSnap.data();

  // fallback for old users
  if (!privateData.plan) {
    privateData.plan = "gift_trial";
  }

  if (privateData.monthlyPostCount == null) {
    privateData.monthlyPostCount = 0;
  }

  if (!privateData.monthlyPostResetAt) {
    privateData.monthlyPostResetAt =
      Date.now() + 30 * 24 * 60 * 60 * 1000;
  }
}


// PUBLIC (username)
const publicSnap = await getDoc(doc(db, "publicUsers", firebaseUser.uid));

const publicData = publicSnap.exists()
  ? publicSnap.data()
  : {};

const userData = {
  ...baseUser,
  ...privateData,

  username:
    publicData.username ||
    firebaseUser.displayName ||
    firebaseUser.email?.split("@")[0] ||
    "",

  accountType: publicData.accountType || "",
};

setUser(userData);
localStorage.setItem("user", JSON.stringify(userData));
} else {
        setUser(null);
        localStorage.removeItem("user");
      }

      setLoading(false); // ✅ IMPORTANT: done loading
    });

    return () => unsubscribe();
  }, []);

  const logout = async () => {
    const auth = getAuth();
    await signOut(auth);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
